import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import {
  needsAddressCompletion,
  readExternalChannelAccessFromSession,
} from '../utils/external-channel-access.util';

@Injectable({
  providedIn: 'root',
})
export class ExternalChannelCompleteAddressGuard implements CanActivate {
  private router = inject(Router);


  canActivate(): boolean {
    const data = readExternalChannelAccessFromSession();

    if (!data || !needsAddressCompletion(data.completeAddress)) {
      this.router.navigate(['/']);
      return false;
    }

    return true;
  }
}
